import { l } from '@manychat/manyui'

export const AiIntegrationDescription = l.makeTranslate(
  '{integrationName} integration enables individuals to accomplish a wide range of tasks. The flexibility and intelligence allow handling various types of requests and offering personalized support.',
)
